<template>
  <v-dialog v-model="open" :content-class="$style['dialog']">
    <v-card>
      <v-card-title :class="$style['dialog-card-title']">
        フィルタ
        <v-spacer></v-spacer>
        <v-btn icon @click="onCancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text :class="$style['dialog-card-text']">
        <v-container fluid :class="$style['dialog-container']">
          <v-layout row align-baseline justify-start :class="$style['dialog-form']">
            <v-flex xs4 :class="$style['label']">
              <Label :label="'項目名'" :size="14" />
            </v-flex>
            <v-flex xs8>
              <SelectField
                v-model="input.field"
                name="field"
                text-key="text"
                value-key="value"
                :options="fieldOptions"
                :hide-details="true"
                width="100%"
              />
            </v-flex>
          </v-layout>
          <v-layout row align-baseline justify-start :class="$style['dialog-form']">
            <v-flex xs4 :class="$style['label']">
              <Label :label="'条件'" :size="14" />
            </v-flex>
            <v-flex xs8>
              <SelectField
                v-model="input.cond"
                name="cond"
                text-key="text"
                value-key="cond"
                :options="conditions"
                :hide-details="true"
                width="100%"
              />
            </v-flex>
          </v-layout>
          <v-layout row align-baseline justify-start :class="$style['dialog-form']">
            <v-flex xs4 :class="$style['label']">
              <Label :label="'値'" :size="14" />
            </v-flex>
            <template v-if="useValue">
              <template v-if="fieldType === 'string'">
                <v-flex xs8>
                  <TextField v-model="input.value" name="value" :hide-details="true" width="100%" />
                </v-flex>
              </template>
              <template v-if="fieldType === 'number'">
                <v-flex xs8>
                  <TextField v-model="input.value" name="value" :hide-details="true" />
                </v-flex>
              </template>
              <template v-if="fieldType === 'date'">
                <v-flex xs8>
                  <DateField v-model="input.value" name="value" :hide-details="true" />
                </v-flex>
              </template>
              <template v-if="fieldType === 'datetime'">
                <v-flex xs8>
                  <DatetimeField v-model="input.value" name="value" :hide-details="true" />
                </v-flex>
              </template>
              <template v-if="fieldType === 'select'">
                <v-flex xs8>
                  <SelectField
                    v-model="input.value"
                    name="value"
                    :options="selectionOptions"
                    text-key="text"
                    value-key="value"
                    :hide-details="true"
                    width="100%"
                  />
                </v-flex>
              </template>
            </template>
          </v-layout>
          <v-btn color="primary" @click="onAdd" :disabled="disabledAddButton">
            <v-icon left>add</v-icon>追加
          </v-btn>
        </v-container>
        <v-divider />
        <v-data-table
          :headers="filterColumns"
          :items="filters"
          height="125px"
          no-data-text="フィルタは未設定です"
          disable-sort
          fixed-header
          hide-default-footer
        >
          <template v-slot:item.field="{ value }">
            <span>{{ renderField(value) }}</span>
          </template>
          <template v-slot:item.cond="{ value }">
            <span>{{ renderCondition(value) }}</span>
          </template>
          <template v-slot:item.value="{ item, value }">
            <span>{{ renderValue(item, value) }}</span>
          </template>
          <template v-slot:item.remove="{ item }">
            <v-icon @click="onRemove(item.index)">mdi-close</v-icon>
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-3">
        <v-row class="ma-0" align="baseline" justify="end">
          <v-btn class="mx-1" @click="onApply">
            <v-icon left>mdi-filter-outline</v-icon>適用
          </v-btn>
          <v-btn class="mx-1" @click="onClearAll">
            <v-icon left>mdi-close</v-icon>クリア
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import SelectField from "./field/select";
import TextField from "./field/text";
import DateField from "./field/date";
import DatetimeField from "./field/datetime";
import Label from "./field/label";
export default {
  components: {
    Label,
    SelectField,
    TextField,
    DateField,
    DatetimeField
  },
  props: {
    columns: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      filterColumns: [
        {
          value: "field",
          text: "対象フィールド"
        },
        {
          value: "cond",
          text: "条件"
        },
        {
          value: "value",
          text: "値"
        },
        {
          value: "remove",
          width: 50
        }
      ],
      input: {
        field: "",
        cond: "",
        value: "",
        type: ""
      }
    };
  },
  computed: {
    open: {
      get() {
        return this.$store.getters["filters/open"];
      },
      set(value) {
        if (!value) {
          this.onCancel();
        }
      }
    },
    fieldOptions() {
      return this.columns.reduce((previous, current) => {
        if (current.filter && !(!this.isProvider && current.isProvider)) {
          let fields = [];
          if (!current.hidden) {
            if (current.filter.table) {
              fields.push(current.filter.table);
            }
            fields.push(current.filter.field || current.value);
            previous.push({
              label: current.text,
              value: fields.join(".")
            });
          }
        }
        return previous;
      }, []);
    },
    filters() {
      return this.$store.getters["filters/filters"];
    },
    conditions() {
      return this.$store.getters["filters/conditions"](this.fieldType);
    },
    allConditions() {
      return this.$store.getters["filters/allConditions"];
    },
    fieldType() {
      return this.getColumn().type || "string";
    },
    useValue() {
      if (this.input.cond) {
        const condition = this.conditions.find(
          condition => condition.value === this.input.cond
        );
        return !!condition.useValue;
      }
      return false;
    },
    disabledAddButton() {
      return !(
        this.input.field &&
        this.input.cond &&
        (!this.useValue || (this.input.value != null && this.input.value !== ""))
      );
    },
    selectionOptions() {
      const column = this.getColumn();

      if (Object.keys(column).length) {
        return this.$store.getters[`${column.optionType}/options/options`];
      }

      return [];
    },
    isProvider() {
      return this.$store.getters[`auth/isProvider`];
    }
  },
  watch: {
    fieldType(val) {
      this.input.type = val;
      this.input.cond = "";
      this.input.value = "";
    },
    useValue() {
      this.input.value = "";
    }
  },
  methods: {
    onAdd() {
      this.$store.commit("filters/add", this.input);
      this.onClear();
    },
    onRemove(index) {
      this.$store.commit("filters/remove", { index });
    },
    onClear() {
      this.input = {
        field: "",
        cond: "",
        value: "",
        type: ""
      };
    },
    onApply() {
      this.$store.commit("filters/apply");
      this.onClear();
    },
    onClearAll() {
      this.$store.commit("filters/clearAll");
      this.onClear();
    },
    onCancel() {
      this.$store.commit("filters/cancel");
      this.onClear();
    },
    renderField(value) {
      const fieldOption = this.fieldOptions.find(
        fieldOption => fieldOption.value === value
      );

      return (fieldOption || {}).label || "";
    },
    renderCondition(value) {
      const condition = this.allConditions.find(
        condition => condition.value === value
      );

      return (condition || {}).label || "";
    },
    renderValue(item, value) {
      switch (item.type) {
        case "select":
          const column = this.columns.find(v => v.value === item.field);
          return (
            (
              this.$store.getters[`${column.optionType}/options/options`] || []
            ).find(opt => {
              return opt.value === value;
            }) || {}
          ).label;
      }

      return value;
    },
    getColumn() {
      if (this.input.field) {
        const fields = this.input.field.split(".");
        if (fields.length) {
          const field = fields[fields.length - 1];
          const column = this.columns.find(column => column.value === field);
          return column;
        }
      }

      return {};
    }
  },
  created() {
    // selectタイプの列のoptionsを読み込む
    const column = this.columns.forEach(column => {
      if (column.type === "select") {
        const { optionType, optionParams } = column;
        if (optionType) {
          if (optionParams && Object.keys(optionParams).length) {
            this.$store.dispatch(`${optionType}/options/index`, {
              params: optionParams
            });
          } else {
            this.$store.dispatch(`${optionType}/options/index`, {});
          }
        }
      }
    });
  }
};
</script>
<style module lang="scss">
.dialog {
  max-width: 600px;
}
.dialog-card-title {
  font-size: 16px;
  font-weight: 600;
}
.dialog-card-text.dialog-card-text {
  padding: 0;
}
.dialog-container.dialog-container {
  padding: 20px;
  .dialog-form {
    min-height: 52px;
    padding-bottom: 0;
    :global {
      .v-input {
        font-size: 14px;
      }
    }
  }
}
.dialog-card-actions {
  :global {
    .v-icon {
      padding-right: 5px;
    }
  }
}
</style>
